import React, { Component } from "react";

// Ajax Methods
import ajaxMethods from "../../../api/ajax-methods";

// Ajax End Points
import * as ajaxEndpoints from "../../../api/ajax-endpoints";

import { currency } from "../../../helpers/stringControllers";
import ButtonLoader from "../../../UI/Loaders/Loaders";
import { appInsights } from "../../../config/appInsights";

export default class ProductModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scene: "form",
      productCategoryOptions: [],
      sectorCategoryOptions: [],
      selectedSectorId: props?.properties?.dataRecord?.sector_id || "",
      selectedProductId:
        props?.properties?.dataRecord?.product_category_id || "",
      maxInterestRate:
        props?.properties?.dataRecord?.maximum_interest_rate || "",
      minInterestRate:
        props?.properties?.dataRecord?.minimum_interest_rate || "",
      maxTenure: props?.properties?.dataRecord?.maximum_tenor || "",
      minTenure: props?.properties?.dataRecord?.minimum_tenor || "",
      maxAmount: props?.properties?.dataRecord?.maximum_amount || "",
      minAmount: props?.properties?.dataRecord?.minimum_amount || "",
      message: "",
      showMessage: false,
      showErrorMessage: false,
      loading: false,
    };
  }

  // maximum_amount: "1000000.00"
  // maximum_interest_rate: 18
  // maximum_tenor: 24
  // minimum_amount: "5000.00"
  // minimum_interest_rate: 15
  // minimum_tenor: 6
  // productCategoryCode: "003"
  // productCategoryName: "Asset Finance"
  // sectorName: "entertainment"
  // fetch product category list
  getProductCategories = () => {
    ajaxMethods
      .get(ajaxEndpoints.PRODUCT_CATEGORY_LIST)
      .then((response) => {
        let productCategoryList = [];

        if (response.data.length > 0) {
          productCategoryList = [...response.data];
        } else {
          productCategoryList = [
            {
              code: 0,
              productCategoryName: "No Categories Yet",
            },
          ];
        }
        const productCategoryOptions = productCategoryList.map(
          (ecosystem, index) => {
            const { code, id, productCategoryName } = ecosystem;
            return (
              <option key={index} id={code} value={id}>
                {productCategoryName}
              </option>
            );
          }
        );

        this.setState({
          productCategoryOptions: productCategoryOptions,
        });
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "ProductModal.js",
          },
        });
      });
  };

  getSectorCategories = () => {
    ajaxMethods
      .get(ajaxEndpoints.CATEGORY_LIST)
      .then((response) => {
        let categoryList = [];

        if (response.data.length > 0) {
          categoryList = [...response.data];
        } else {
          categoryList = [
            {
              category_id: 0,
              category_name: "No Categories Yet",
              category_slug: "No Categories Yet",
            },
          ];
        }
        const sectorCategoryOptions = categoryList.map((ecosystem, index) => {
          const { category_id, category_name } = ecosystem;
          return (
            <option key={index} id={category_id} value={category_id}>
              {category_name}
            </option>
          );
        });
        this.setState({
          sectorCategoryOptions: sectorCategoryOptions,
        });
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "ProductModal.js",
          },
        });
      });
  };
  handleEditSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const {
      selectedSectorId,
      selectedProductId,
      maxInterestRate,
      minInterestRate,
      maxTenure,
      minTenure,
      maxAmount,
      minAmount,
    } = this.state;
    const options = {
      sector_id: Number(selectedSectorId),
      product_category_sector_id: Number(this.props.properties.dataRecord.id),
      maximum_interest_rate: Number(maxInterestRate),
      minimum_interest_rate: Number(minInterestRate),
      maximum_tenor: Number(maxTenure),
      minimum_tenor: Number(minTenure),
      maximum_amount: Number(maxAmount),
      minimum_amount: Number(minAmount),
      product_category_id: Number(selectedProductId),
    };
    ajaxMethods
      .post(ajaxEndpoints.UPDATE_PRODUCT_TO_SECTOR, options)
      .then((response) => {
        this.setState({ loading: false });
        let message = "";
        if (response.status === 200) {
          message = response.data.message;
          this.setState({ message: message, showMessage: true });
        } else if (response.status === 400) {
          message = response.data.message;
          return this.setState({ message: message, showErrorMessage: true });
        } else {
          message = "Unable to connect to Advancly services";
          return this.setState({ message: message, showErrorMessage: true });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "ProductModal.js",
          },
        });
        let message = "Unable to connect to Advancly services";
        return this.setState({
          message: message,
          showErrorMessage: true,
          loading: false,
        });
      });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const {
      selectedSectorId,
      selectedProductId,
      maxInterestRate,
      minInterestRate,
      maxTenure,
      minTenure,
      maxAmount,
      minAmount,
    } = this.state;
    const options = {
      sector_id: Number(selectedSectorId),
      product_category_id: Number(selectedProductId),
      maximum_interest_rate: Number(maxInterestRate),
      minimum_interest_rate: Number(minInterestRate),
      maximum_tenor: Number(maxTenure),
      minimum_tenor: Number(minTenure),
      maximum_amount: Number(maxAmount),
      minimum_amount: Number(minAmount),
    };
    ajaxMethods
      .post(ajaxEndpoints.ADD_PRODUCT_TO_SECTOR, options)
      .then((response) => {
        this.setState({ loading: false });
        let message = "";
        if (response.status === 200) {
          message = response.data.message;
          this.setState({ message: message, showMessage: true });
        } else if (response.status === 400) {
          message = response.data.message;
          return this.setState({ message: message, showErrorMessage: true });
        } else {
          message = "Unable to connect to Advancly services";
          return this.setState({ message: message, showErrorMessage: true });
        }
      })
      .catch((error) => {
        appInsights.trackException({
          exception: error,
          properties: {
            fileName: "ProductModal.js",
          },
        });
        let message = "Unable to connect to Advancly services";
        return this.setState({
          message: message,
          showErrorMessage: true,
          loading: false,
        });
      });
  };

  handleOptionSelect = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      showMessage: false,
      showErrorMessage: false,
    });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      showMessage: false,
      showErrorMessage: false,
    });
  };

  cancelHandler = () => {};

  componentDidMount() {
    this.getSectorCategories();
    this.getProductCategories();
  }

  render() {
    const {
      scene,
      productCategoryOptions,
      sectorCategoryOptions,
      selectedSectorId,
      selectedProductId,
      maxInterestRate,
      minInterestRate,
      maxTenure,
      minTenure,
      maxAmount,
      minAmount,
      message,
      showMessage,
      showErrorMessage,
      loading,
    } = this.state;

    return (
      <div className="Modal__dialog animated slideInDown" role="document">
        <div
          className="IssueModal Modal__content"
          style={{ overflow: "hidden" }}
        >
          <div className="Modal__body">
            <h3
              className="Modal__title m-b-1 p-x-2 p-y-1 "
              style={{ backgroundColor: "#713fff", color: "#fff" }}
            >
              {this.props.properties.dataRecord && <span>Edit</span>} Product
              Category Sector
            </h3>
            {/* Product Form */}
            {(() => {
              switch (scene) {
                case "form":
                  return (
                    <form>
                      <div className="row">
                        <div className="col-xs-6">
                          <label className="label-txt">Sector</label>
                          <div className="form-group inputWithIcon">
                            <select
                              className="round user__form form-control form-load"
                              name="selectedSectorId"
                              placeholder="Select a Sector"
                              title="Select a Sector"
                              id="selectedSectorId"
                              value={selectedSectorId}
                              onChange={(e) => this.handleOptionSelect(e)}
                            >
                              <option selected>Select a Sector</option>
                              {sectorCategoryOptions}
                            </select>
                            <i className="adv-aggregator-icon fas fa-building"></i>
                          </div>
                        </div>
                        <div className="col-xs-6">
                          <label className="label-txt">Product Category</label>
                          <div className="form-group inputWithIcon">
                            <select
                              className="round user__form form-control"
                              name="selectedProductId"
                              placeholder="Select Product category"
                              title="Select a Product"
                              id="selectedProductId"
                              value={selectedProductId}
                              onChange={(e) => this.handleOptionSelect(e)}
                            >
                              <option selected>Select a Category</option>
                              {productCategoryOptions}
                            </select>

                            <i className="adv-aggregator-icon fas fa-university"></i>
                          </div>
                        </div>
                      </div>

                      <div className="row m-t-1">
                        <div className="col-xs-6">
                          <label className="label-txt">
                            Minimum Interest Rate
                          </label>
                          <div className="form-group inputWithIcon">
                            <input
                              type="number"
                              className="form-control"
                              name="minInterestRate"
                              value={minInterestRate}
                              onChange={this.handleChange}
                            />
                            <i className="adv-aggregator-icon fas fa-percent"></i>
                          </div>
                        </div>
                        <div className="col-xs-6">
                          <label className="label-txt">
                            Maximum Interest Rate
                          </label>
                          <div className="form-group inputWithIcon">
                            <input
                              type="number"
                              className="form-control"
                              value={maxInterestRate}
                              name="maxInterestRate"
                              onChange={this.handleChange}
                            />
                            <i className="adv-aggregator-icon fas fa-percent"></i>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xs-6">
                          <label className="label-txt">Minimum Tenure</label>
                          <div className="form-group inputWithIcon">
                            <input
                              type="number"
                              className="form-control"
                              data-form="minTenure"
                              name="minTenure"
                              value={minTenure}
                              onChange={this.handleChange}
                            />
                            <i className="adv-aggregator-icon fas fa-chevron-left"></i>
                          </div>
                        </div>
                        <div className="col-xs-6">
                          <label className="label-txt">Maximum Tenure</label>
                          <div className="form-group inputWithIcon">
                            <input
                              type="number"
                              className="form-control"
                              data-form="maxTenure"
                              name="maxTenure"
                              value={maxTenure}
                              onChange={this.handleChange}
                            />
                            <i className="adv-aggregator-icon fas fa-chevron-right"></i>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-xs-6">
                          <label className="label-txt">
                            Minimum Amount {currency(minAmount)}
                          </label>
                          <div className="form-group inputWithIcon">
                            <input
                              type="number"
                              className="form-control"
                              data-form="minAmount"
                              name="minAmount"
                              value={minAmount}
                              onChange={this.handleChange}
                            />
                            <i className="adv-aggregator-icon fas fa-money"></i>
                          </div>
                        </div>
                        <div className="col-xs-6">
                          <label className="label-txt">
                            Maximum Amount {currency(maxAmount)}
                          </label>
                          <div className="form-group inputWithIcon">
                            <input
                              type="text"
                              className="form-control"
                              name="maxAmount"
                              value={maxAmount}
                              onChange={this.handleChange}
                            />
                            <i className="adv-aggregator-icon fas fa-money"></i>
                          </div>
                        </div>
                      </div>
                      {showMessage && (
                        <span className="text-success">{message}</span>
                      )}
                      {showErrorMessage && (
                        <span className="text-danger">{message}</span>
                      )}
                      {!this.props.properties.dataRecord && (
                        <div className="grid__full m-t-2">
                          <button
                            type="submit"
                            className="zoom-element btn login-btn"
                            onClick={this.handleSubmit}
                          >
                            &nbsp; Submit {loading && <ButtonLoader />}
                          </button>
                        </div>
                      )}
                      {this.props.properties.dataRecord && (
                        <div className="grid__full m-t-2">
                          <button
                            type="submit"
                            className="zoom-element btn login-btn"
                            onClick={this.handleEditSubmit}
                          >
                            &nbsp; Update {loading && <ButtonLoader />}
                          </button>
                        </div>
                      )}
                    </form>
                  );

                default:
                  return null;
              }
            })()}
          </div>
        </div>
      </div>
    );
  }
}
